import React from 'react';
import { createPortal } from 'react-dom';
import './ErrorModal.css';

interface ErrorModalProps {
  visible: boolean;
  title?: string;
  message?: string;
  onClose: () => void;
  children?: React.ReactNode;
}

/**
 * 统一错误提示弹窗
 * 只显示确定按钮，用于错误提示
 * 使用 React Portal 渲染到 document.body，避免受组件卸载影响
 */
export const ErrorModal: React.FC<ErrorModalProps> = ({
  visible,
  title = '错误',
  message,
  onClose,
  children,
}) => {
  if (!visible) return null;

  // 确保 document.body 存在
  if (typeof document === 'undefined' || !document.body) {
    console.error('[ErrorModal] document.body not available, using alert fallback');
    alert(`${title}: ${message || String(children)}`);
    return null;
  }

  try {
    // 使用 Portal 将弹窗渲染到 document.body
    return createPortal(
      <div className="error-mask" onClick={onClose}>
        <div className="error-modal" onClick={(e) => e.stopPropagation()}>
          <h3 className="error-title">{title}</h3>
          <div className="error-body">
            {children ? children : (message || '未知错误')}
          </div>
          <div className="error-actions">
            <button className="error-confirm-btn" onClick={onClose}>
              确定
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
  } catch (error) {
    console.error('[ErrorModal] Render error, using alert fallback:', error);
    alert(`${title}: ${message || String(children)}`);
    return null;
  }
};

